<template>
  <MainTab :main-title="mainTitle">
    <ContentWrapper>
      <template v-if="localRegistration" #header>
        <template v-if="localRegistration.dea_certificate_available">
          <p class="dea-heading--medium__m">Il tuo attestato è pronto</p>
        </template>
        <template v-else-if="localRegistration.survey_completed_date || !localRegistration.linked_event.has_survey">
          <p class="dea-heading--medium__m">Il certificato viene rilasciato sul pacchetto completo</p>
        </template>
        <template v-else-if="localRegistration">
          <p class="dea-heading--medium__m">Certificato non disponibile</p>
        </template>
      </template>
      <template v-if="localRegistration" #default>
        <template v-if="localRegistration.dea_certificate_available">
          <div>
            <p>
              <Buttons
                type="a"
                :href="localRegistration.dea_certificate_url"
                target="_blank"
                class="dea-button--large"
                icon="download"
                >Scarica attestato</Buttons
              >
            </p>
            <p class="dea-heading--medium__m">
              Puoi trovare il tuo attestato, i materiali e tutti i dettagli del
              {{ localRegistration.linked_event.type_label }} in ogni momento nella sezione
              <Links
                :href="config.myevents_url"
                label-class="dea-heading--medium__m"
                class-name="dea-links dea-links--generic-dark-grey"
                >'I miei eventi'</Links
              >
              della tua Area personale.
            </p>
          </div>
          <div
            v-if="localRegistration.linked_event.sofia_url && localRegistration.linked_event.sofia && showSofiaSection"
          >
            <p v-if="localRegistration.linked_event.ticket_available" class="dea-heading--medium__m">
              Se sei un docente di ruolo e ti sei iscritto a questa iniziativa formativa anche su S.O.F.I.A., da questo
              momento, puoi scaricare il tuo attestato certificato anche da qui.
            </p>
            <p v-else class="dea-heading--medium__m">
              Se sei un docente di ruolo e ti sei iscritto a questa iniziativa formativa anche sul sito ministeriale
              S.O.F.I.A., ti invieremo una mail appena il tuo attestato certificato è disponibile.
            </p>
            <p>
              <Buttons
                type="a"
                :href="localRegistration.linked_event.sofia_url"
                target="_blank"
                class="dea-button--large"
                icon="download"
                >Vai a S.O.F.I.A.</Buttons
              >
            </p>
          </div>
        </template>
        <router-link
          v-else-if="localRegistration.survey_completed_date || !localRegistration.linked_event.has_survey"
          :to="{ name: 'events', params: { ticketFilter: 'past', updateRegistrations: true } }"
          ><Buttons class="dea-button--large dea-button--mid dea-button--iconRight" icon="go-to"
            >Torna alla lista</Buttons
          ></router-link
        >
        <Buttons
          v-else
          class="dea-button--large dea-button--mid dea-button--iconRight"
          icon="go-to"
          @click="completeSurvey"
          >Rispondi al questionario e scarica attestati</Buttons
        >
      </template>
      <Loader v-else></Loader>
    </ContentWrapper>
  </MainTab>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Buttons from "@/components/elements/Buttons";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import MainTab from "~/components/events/components/MainTab";

export default {
  name: "EventsDownloadCertificate",
  components: {
    Buttons,
    ContentWrapper,
    Links,
    Loader,
    MainTab,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    confirmButtonText: {
      type: String,
      default: "Conferma e prosegui",
    },
    sofiaEnabledType: {
      type: Array,
      default: () => {
        return ["seminar", "online-course", "convention"];
      },
    },
  },
  computed: {
    ...mapGetters(["user", "config", "localRegistration", "certificateLoaded"]),
    showSofiaSection() {
      return this.sofiaEnabledType.indexOf(this.localRegistration.linked_event.type);
    },
  },
  mounted() {
    this.fetchRegistration({ registrationId: this.$route.params.registration, force: false });
  },
  methods: {
    ...mapActions(["fetchRegistration"]),
    ...mapMutations([]),
    completeSurvey() {
      this.$router.push({ name: "survey", params: { registration: this.$route.params.registration } });
    },
  },
};
</script>
